import { useBaseApiCall } from '@/api/factory/base/api';
import { useHandleMutationError } from '@/api/utils';
import { useMutation } from '@tanstack/react-query';

type CheckEmailResponse = {
  emailTaken: boolean;
};

export const useCheckEmailMutation = () => {
  const mutationFn = useBaseApiCall<CheckEmailResponse, [string]>(
    (api, email) => api.post(`customers/checkEmail`, { email }),
  );
  const handleMutationError = useHandleMutationError();

  return useMutation({
    mutationFn,
    onError: handleMutationError,
  });
};
